import { CompanyService } from "src/app/core/services/company/company.service";
import { InformationFormatting } from "src/app/core/helpers/information-formatting/information-formatting";
import { IContribuyente } from "src/app/core/models/business-information/ibusiness-information";
import { catchError, map, timeout } from "rxjs/operators";
import {
  Component,
  ElementRef,
  EventEmitter,
  OnInit,
  Output,
  ViewChild,
} from "@angular/core";
import { environment } from "../../../../../environments/environment";
import { IUser } from "./../../../../core/models/user/user";
import { LocalStorageService } from "./../../../../core/services/local-storage/local-storage.service";
import { RoutingPath } from "./../../../../configs/routing-path";
import { Observable, throwError } from "rxjs";
import { UserService } from "./../../../../core/services/user/user.service";
import { Router } from "@angular/router";
declare var dataLayer;
@Component({
  selector: "app-header",
  templateUrl: "./header.component.html",
  styleUrls: ["./header.component.scss"],
})
export class HeaderComponent implements OnInit {
  public home;
  public userLoggin: IUser;
  public companyData: IContribuyente;
  cerrando = false;
  public dropActive: boolean;
  public modal: boolean;
  public change;
  public menu: boolean;

  public urlHome;
  public urlAffiliation;
  public urlRetiro;
  public urlBusinessInformation;
  public urlWorkersInformation;
  public urlPqrs;
  public $companyData: Observable<IContribuyente>;
  public tokenInicial:string;

  public newSession:string;

  @ViewChild("dropAvatar", {static: false}) dropAvatar: ElementRef;
  @ViewChild("elmAvatar", {static: false}) elmAvatar: ElementRef;

  @Output() overlayActive: EventEmitter<boolean>;

  constructor(
    private _storage: LocalStorageService,
    private _user: UserService,
    private _company: CompanyService,
    private router: Router
  ) {
    this.overlayActive = new EventEmitter();
    window.addEventListener('storage', this.onStorageChange.bind(this));
  }

  ngOnInit() {
    this.tokenInicial = this._storage.getItemString(environment.LOCAL_STORAGE.AUTHORIZATION_TOKEN);
    this.userLoggin = this._storage.getItemJSON(environment.LOCAL_STORAGE.USER_LOGGED_IN);
    this.home = RoutingPath.appRouting.components.dashboard.pages.home.path;
    this.newSession = this._storage.getItemString("newSession");
    this.companyData = this._storage.getItemJSON(
      environment.LOCAL_STORAGE.BUSINESS_INFORMATION
    );
    this.change =
      RoutingPath.appRouting.components.user.path +
      "/" +
      RoutingPath.appRouting.components.user.pages.change_password.path;

     if (this.companyData === undefined || this.companyData === null) {
      this.getBusinnessInformation();
    } 

    this.urlHome =
      RoutingPath.appRouting.components.dashboard.path +
      "/" +
      RoutingPath.appRouting.components.dashboard.pages.home.path;
    this.urlAffiliation =
      RoutingPath.appRouting.components.dashboard.path +
      "/" +
      RoutingPath.appRouting.components.dashboard.pages.affiliation.path;
    this.urlRetiro =
      RoutingPath.appRouting.components.dashboard.path +
      "/" +
      RoutingPath.appRouting.components.dashboard.pages.retreat.path;
    this.urlBusinessInformation =
      RoutingPath.appRouting.components.business_information.path +
      "/" +
      RoutingPath.appRouting.components.business_information.pages.home.path;
    this.urlWorkersInformation =
      RoutingPath.appRouting.components.workers_information.path;
    this.urlPqrs = RoutingPath.appRouting.components.pqrs.path;
    if(this.newSession=="true"){
      this.alertaNuevaSesion();
    }
  }

  public logout() {
    this.cerrando = true;
    this._storage.removeItem("newSession");
    this.newSession = null;
    this._user
      .logout(this.userLoggin.tokenId)
      .pipe(
        map((response) => {
          this._storage.removeItem(environment.LOCAL_STORAGE.LOGIN_USER_TOKEN);
          this._storage.removeItem(environment.LOCAL_STORAGE.USER_LOGGED_IN);
          this._storage.removeItem(environment.LOCAL_STORAGE.AUTHORIZATION_TOKEN);
          this._storage.clear();
          this._storage.removeItem(environment.LOCAL_STORAGE.INFO_SHOW);
          location.href = "//www.colsubsidio.com";
          // this.cerrando = false;
        }),
        catchError((err) => {
          this.cerrando = false;
          return throwError(err);
        })
      )
      .subscribe();
  }

  private onStorageChange(event: StorageEvent): void {
    if (event.storageArea.token != this.tokenInicial) {
      this._storage.setItem("newSession",true);
      this._storage.removeItem(environment.LOCAL_STORAGE.BUSINESS_INFORMATION);
      this.getBusinnessInformation()
      location.href = RoutingPath.appRouting.components.dashboard+"#/tablero"+"/inicio";
    }else{
      this._storage.removeItem("newSession");
      this.newSession = null;
    }
  }

  dropDown(e) {
    this.dropActive = e;
  }
  log() {}

  clickToggle(e) {
    this.modal = !this.modal;
  }

  getBusinnessInformation() {
    this._company
      .getBusinnessInformation(
        InformationFormatting.returnNameDocumentCompany(
          this.userLoggin.docTypeCompany
        ),
        this.userLoggin.docNumberCompany,
        this.userLoggin.checkDigit
      )
      .pipe(
        map((response) => {
          this.companyData = response.body.data[0].contribuyente;
          this._company.setBusinnessInformation(this.companyData);
          this.$companyData = this._company.getBusinnessInformationObs();
          this._storage.stringifyItem(
            environment.LOCAL_STORAGE.BUSINESS_INFORMATION,
            this.companyData
          );
        })
      )
      .subscribe();
  }

  toogleMenu() {
    this.menu = !this.menu;
  }
  alertaNuevaSesion(){

    let isBoss = confirm("Has iniciado sesión con un usuario diferente en el mismo navegador, se refrescaran las pestañas con la información de la empresa");
    if (isBoss) {
      this.getBusinnessInformation();
      this._storage.removeItem("newSession");
      this.newSession = null;      
    }

  }
}